import { createSlice } from "@reduxjs/toolkit";
export const boidDetailsSlice = createSlice({
  name: "boidDetails",
  initialState: {
    boidList: [],
    createMeroShareId: null,
    rList: [],
    errors: {},
  },
  reducers: {
    setFdpId: (state, action) => {
      state.fdpId = action.payload;
    },
    setFdpIdDesc: (state, action) => {
      state.fdpIdDesc = action.payload;
    },
    setHasBoid: (state, action) => {
      state.hasBoid = action.payload;
      state.errors = {};
    },
    setCreateBoid: (state, action) => {
      state.createBoid = action.payload;
      state.errors = {};
    },
    setCreateMeroShareId: (state, action) => {
      state.createMeroShareId = action.payload;
      state.errors = {};
    },
    setForwardBoid: (state, action) => {
      state.boidList.forEach((boid) => {
        if (boid.dpId + boid.boid === action.payload) {
          if (!boid.isForwarded) {
            boid.op = "U";
          }
          boid.isForwarded = true;
        } else {
          if (boid.isForwarded) {
            boid.op = "U";
          }
          boid.isForwarded = false;
        }
      });
      state.errors = {};
    },
    addBoid: (state, action) => {
      state.boidList.push({
        fullBoId: action.payload.fullBoId,
        boid: action.payload.boid,
        dpId: action.payload.dpId,
        dpIdDesc: action.payload.dpIdDesc,
        isForwarded: !state.boidList.length,
        op: "I",
      });
      state.errors = {};
    },
    removeBoid: (state, action) => {
      state.boidList = state.boidList.filter((boid) => {
        if (boid.dpId + boid.boid !== action.payload) {
          return true;
        } else {
          if (boid.id) state.rList.push(boid.id);
        }
      });
    },
    setBoidData: (state, action) => {
      state.boidList = action.payload;
      state.hasBoid = state.boidList.length > 0;
      state.errors = {};
    },
    resetBoidData: (state, action) => {
      state.boidList = [
        ...state.boidList.filter(
          (b) => b.id && !action.payload.find((d2) => d2.id == b.id)
        ),
        ...action.payload,
      ].map((d) => ({ ...d, op: "N" }));
      state.rList = [];
      state.hasBoid = state.boidList.length > 0;
    },
    setBoidOtherData: (state, action) => {
      state.createBoid = action.payload.createBoid;
      state.createMeroShareId = action.payload.createMeroShareId;
      state.fdpId = action.payload.fdpId;
    },
    clearBoidData: (state, action) => {
      state.boidList.forEach((b) => (b.op = "N"));
    },
    setBoidDetailsError: (state, action) => {
      state.errors.boidDetailsError = {};
      state.errors.boidDetailsError.message = action.payload.message;
      state.errors.boidDetailsError.section = action.payload.section;
    },
  },
});

export const {
  clearBoidData,
  setFdpId,
  setBoidOtherData,
  setBoidData,
  resetBoidData,
  setHasBoid,
  setForwardBoid,
  addBoid,
  removeBoid,
  setCreateBoid,
  setCreateMeroShareId,
  setBoidDetailsError,
  setFdpIdDesc,
} = boidDetailsSlice.actions;

export default boidDetailsSlice.reducer;
